const StatCard = ({ icon, label, value, sub, accent, gradient }) => (
  <div
    className={`bg-bg-surface border border-border rounded-2xl p-5 flex items-start gap-4 card-hover ${gradient ? "glow-primary" : ""}`}
  >
    <div
      className={`p-2.5 rounded-xl flex-shrink-0 ${accent ?? "bg-primary/10"}`}
    >
      {icon}
    </div>
    <div>
      <p className="text-xs text-text-muted mb-1">{label}</p>
      <p className="text-xl font-semibold text-text-primary">{value}</p>
      {sub && <p className="text-xs text-text-muted mt-0.5">{sub}</p>}
    </div>
  </div>
);

export default StatCard;
